import { useEffect, useState } from "react";

export const useScreenWidth = () => {
  let persistedWidth;
  if (typeof window !== "undefined") {
    persistedWidth = JSON.parse(<string>localStorage.getItem("screenWidth"));
  }
  const [screenWidth, setScreenWidth] = useState(persistedWidth ?? undefined);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleResize = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("screenWidth", JSON.stringify(window.innerWidth));
      setScreenWidth(window.innerWidth);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return [screenWidth];
};
